import React, {Component} from 'react';
import SelectRadioGroup2 from '../../../Shared/components/Forms/selects/SelectRadioGroup2';
import _ from "lodash";
import {normalizeName} from '../../../../Utils/Analizer.js'
import NewSimpleSelect from "../../../Shared/components//Forms/selects/NewSimpleSelect";
import {
    MAP_SUBTIPOS_ENTITY_CONFIG, ICONS
} from '../../../../config/globalFrontEndConfig.js'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class EntitiesFilter extends Component {
    
    constructor(props) {
        super(props);
        
        if (props.filtroEntitySeleccionado) {
            this.state = {
                filtroEntitySeleccionado: props.filtroEntitySeleccionado
            }
        } else {
            this.state = {
                filtroEntitySeleccionado: {
                    tipo: [],
                    subtipo: [],
                    geo: {
                        userLocation: {}
                    }
                },
                showListing: true,
                showMap: false
            }
        }
        
        this.configSelectRadioSubtipoProtectora = {
            mainId: "subtipo-protectora-filter",
            mainLabel: "Tipo de protectora",
            selected: this.state.filtroEntitySeleccionado.subtipo,
            showLabel: false,
            infoSelect: Object.keys(MAP_SUBTIPOS_ENTITY_CONFIG["protectora"]).map(subtipo => MAP_SUBTIPOS_ENTITY_CONFIG["protectora"][subtipo]),
            methodChange: this.changeTipoProtectora.bind(this)
        };
        
        
        this.configSimpleSelectProvincia = {
            id: "idFilterProvincias",
            collSize: "",
            seleccionado: this.state.filtroEntitySeleccionado.geo.provincia,
            placeHolder: "Provincias",
            all: {
                label: "Provincia",
                value: "all"
            },
            methodChange: this.changeProvincia.bind(this)
        };
        
        this.configSimpleSelectMunicipio = {
            id: "idFilterMunicipios",
            collSize: "",
            seleccionado: this.state.filtroEntitySeleccionado.geo.municipio,
            placeHolder: "Municipios",
            all: {
                label: "Municipio",
                value: "all"
            },
            methodChange: this.changeMunicipio.bind(this)
        };
        
        
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.onShowMap = this.onShowMap.bind(this);
        this.onShowListing = this.onShowListing.bind(this);
        this.onSearchCurrentLocation = this.onSearchCurrentLocation.bind(this);
    }
    
    changeTipoProtectora(nuevoTipo) {
        //console.log("EntitiesFilter::changeTipoProtectora() -> " +nuevoTipo);
        let tiposSeleccionados = this.state.filtroEntitySeleccionado.subtipo || [];
        
        let index = tiposSeleccionados.indexOf(nuevoTipo);
        
        if (index === -1) {
            tiposSeleccionados.push(nuevoTipo);
        } else {
            tiposSeleccionados.splice(index, 1);
        }
        
        this.setState({
            filtroEntitySeleccionado: {
                subtipo: tiposSeleccionados
            }
        }, () => {
            this.onChangeFilter(this.state.filtroEntitySeleccionado);
        })
    }
    
    changeProvincia(nuevaProvincia) {
        if (normalizeName(nuevaProvincia) !== this.state.filtroEntitySeleccionado.geo.provincia) {
            this.setState({
                filtroEntitySeleccionado: {
                    geo: {provincia: nuevaProvincia}
                }
            }, () => {
                this.onChangeFilter(this.state.filtroEntitySeleccionado);
            })
        }
    }
    
    changeMunicipio(nuevoMunicipio) {
        // console.log("EntitiesFilter::changeMunicipio() -> " + nuevoMunicipio);
        this.setState({
            filtroEntitySeleccionado: {
                geo: {
                    ...this.state.filtroEntitySeleccionado.geo,
                    municipio: nuevoMunicipio
                }
            }
        }, () => {
            this.onChangeFilter(this.state.filtroEntitySeleccionado);
        })
    }
    
    
    onSearchCurrentLocation() {
        
        let elements = document.querySelectorAll(".buttonBuscarCerca > i")
        if (elements) {
            elements.forEach((element) => {
                element.classList.remove('la-crosshairs');
                element.classList.add('la-sync-alt');
                element.classList.add('spin');
            })
        }
        
        // console.log("EntitiesFilter::onSearchCurrentLocation()");
        this.props.onSearchCurrentLocation()
    }
    
    
    onChangeFilter(filtroEntitySeleccionado) {
        //console.log("EntitiesFilter::onChangeFilter() -> subtipo = '" + filtroEntitySeleccionado?.subtipo + "'");
        this.props.onChangeFilter(filtroEntitySeleccionado);
    }
    
    onShowListing() {
        //console.log("EntitiesFilter::onShowListing()");
        this.setState({
            showMap: false,
            showListing: true
        })
        this.props.onShowListing();
    }
    
    onShowMap() {
        //console.log("EntitiesFilter::onsShowMap()");
        this.setState({
            showMap: true,
            showListing: false
        })
        this.props.onShowMap();
    }
    
    
    render() {
        //console.log("EntitiesFilter::render() -> subtipo = '" + this.state?.filtroEntitySeleccionado?.subtipo + "'");
        let mobileModeClass = "";
        if (this.props.config && this.props.config.mobileMode) {
            mobileModeClass = " mobileMode"
        }
        let useUserLocation = (this.props.filtroEntitySeleccionado && this.props.filtroEntitySeleccionado.geo.userLocation && this.props.filtroEntitySeleccionado.geo.userLocation.useUserLocation) ? true : false
        let municipiosData
        if (this.props?.paramsFilter?.municipios && this.props.paramsFilter.municipios[this.state.filtroEntitySeleccionado?.geo?.provincia]) {
            municipiosData = this.props?.paramsFilter?.municipios[this.state.filtroEntitySeleccionado?.geo?.provincia]
        }
        return (
            <div>
                
                <div className="icon-wrapper-entities">
                    <div className="quick-filter">
                        <a className={"button-filter btn btn-outline-primary btn-quick-filter-especie" + ((this.props.showListing) ? " btn-active" : "")}>
                            <FontAwesomeIcon
                                icon={ICONS.filterButton.faIcon} color={ICONS.filterButton.colorIcon}/> Filtrar</a>
                        
                        
                        <a onClick={() => {
                            this.onShowListing()
                        }}
                           href="#listing"
                           className={"btn btn-outline-primary btn-quick-filter-especie" + ((this.props.showListing) ? " btn-active" : "")}><FontAwesomeIcon
                            icon={ICONS.listingButton.faIcon} color={ICONS.listingButton.colorIcon}/> Listado</a>
                        <a onClick={() => {
                            this.onShowMap()
                        }}
                           href="#mapa"
                           className={"btn btn-outline-primary btn-quick-filter-especie " + ((this.props.showMap) ? " btn-active" : "")}><FontAwesomeIcon
                            icon={ICONS.mapButton.faIcon} color={ICONS.mapButton.colorIcon}/> Mapa</a>
                    </div>
                </div>
                <div id="animals-filter" className={" sidebar-filter-default" + mobileModeClass}>
                    
                    <div className="sidebar-filter-default__section filter-result">
                        <button id="btn-result-filter"
                                className="btn btn-primary btn-block btn-lg index-resume__search-button button-filter">
                            <span className={"las la-lg la-search"}/>
                            <span
                                className="text"> Ver {(this.props.totalRecords === 1) ? this.props.totalRecords + " resultado" : this.props.totalRecords + " resultados"}</span>
                        </button>
                    </div>
                    <div className="sidebar-filter-default__section">
                        <h4 className="sidebar-filter-default__title"><FontAwesomeIcon
                            icon={ICONS.filterButton.faIcon} color={ICONS.filterButton.colorIcon}/> Filtrar
                            {/*<span className="las la-filter"/>*/}
                            {/*<span className="sidebar-filter-default__result"> ({this.props.totalRecords})</span>*/}
                        </h4>
                    </div>
                    
                    <hr/>
                    <div className="sidebar-filter-default__section">
                        
                        <button onClick={this.onSearchCurrentLocation}
                                href="#listing"
                                className={"btn btn-outline-primary buttonBuscarCerca"}>
                            <i className="las la-crosshairs"/> Cerca de mi
                        </button>
                    </div>
                    <hr/>
                    {this.props?.paramsFilter?.provincias?.length > 0 &&
                        <div className="sidebar-filter-default__section">
                            <h6 className="sidebar-filter-default__heading">Provincia</h6>
                            <NewSimpleSelect
                                configSearch={{
                                    ...this.configSimpleSelectProvincia,
                                    seleccionado: this.state?.filtroEntitySeleccionado?.geo?.provincia,
                                }}
                                data={this.props?.paramsFilter?.provincias}
                            />
                        </div>
                    }
                    {municipiosData &&
                        <div className="sidebar-filter-default__section">
                            <h6 className="sidebar-filter-default__heading">Municipio</h6>
                            <NewSimpleSelect
                                configSearch={{
                                    ...this.configSimpleSelectMunicipio,
                                    seleccionado: this.state?.filtroEntitySeleccionado?.geo?.municipio,
                                }}
                                data={municipiosData}
                            />
                        </div>
                    }
                    <div className="sidebar-filter-default__section">
                        <h6 className="sidebar-filter-default__heading">Tipo de protectora</h6>
                        <SelectRadioGroup2
                            configSelectRadioGroup={{
                                ...this.configSelectRadioSubtipoProtectora,
                                selected: this.state.filtroEntitySeleccionado.subtipo,
                            }}
                        />
                    </div>
                
                </div>
            </div>
        );
    }
    
    
    shouldComponentUpdate(nextProps, nextState) {
        return true
    }
    
    componentDidMount() {
        const btnFilterResult = $('#btn-result-filter');
        const divFilterResult = $('.filter-result');
        const elemIconWrapper = $('.icon-wrapper-entities');
        
        $(window).on('scroll', function () {
            let topIconWrapper = (elemIconWrapper && elemIconWrapper.offset() && elemIconWrapper.offset().top) ? elemIconWrapper.offset().top : 0
            if (($(window).scrollTop() + $(window).height() > $('#animals-filter').outerHeight() + topIconWrapper + $(window).height() ||
                ($(window).scrollTop() + $(window).height() < topIconWrapper + $(window).height() - 100))) {
                btnFilterResult.css("display", "none");
            } else {
                btnFilterResult.css("display", "block");
            }
            if ($(window).scrollTop() <= 70) {
                divFilterResult.css({top: (66 - $(window).scrollTop()) + 'px'});
            }
            
            if ($(window).scrollTop() > 70 && divFilterResult.css('top') !== "0px") {
                divFilterResult.css({top: 0 + 'px'});
            }
        });
        
        $('.button-filter').on("click", (e) => {
            let burguer = $(e.currentTarget);
            if (burguer.hasClass("clicked")) {
                $('.button-filter').removeClass("clicked")
                $('#animals-filter').hide();
            } else {
                $('.button-filter').addClass("clicked")
                $('#animals-filter').show();
            }
            $('body,html').stop(true, true).animate({scrollTop: $('#animals-list').offset().top}, 0);
        });
        window.addEventListener('click', function (e) {
            const buttonFilters = document.getElementsByClassName('button-filter');
            let buttonFilterIsTarget = [].map.call(buttonFilters, elem => elem.contains(e.target)).some(result => result)
            if (document.getElementById('animals-filter')?.contains(e.target) ||
                buttonFilterIsTarget) {
            } else {
                let buttonFilterHasClicked = [].map.call(buttonFilters, elem => elem.classList.contains('clicked')).some(result => result)
                if (buttonFilterHasClicked) {
                    $('#animals-filter').hide();
                    $('.button-filter').removeClass("clicked");
                }
            }
        });
    }
    
    componentDidUpdate(prevProps, prevState, prevContext) {
        //console.log("EntitiesFilter::componentDidUpdate()");
        //console.log(this.props.filtroEntitySeleccionado);
        //console.log(this.state.filtroEntitySeleccionado);
        if (!_.isEqual(this.props.filtroEntitySeleccionado, this.state.filtroEntitySeleccionado)) {
            //console.log("el filtro ha cambiado");
            this.setState({
                filtroEntitySeleccionado: this.props.filtroEntitySeleccionado
            })
        }else{
            //console.log("el filtro no ha cambiado");
        }
        if (this.props.filtroEntitySeleccionado?.geo?.userLocation?.useUserLocation) {
            let elements = document.querySelectorAll(".buttonBuscarCerca >i")
            if (elements) {
                elements.forEach((element) => {
                    element.classList.remove('spin');
                    element.classList.remove('la-sync-alt');
                    element.classList.add('la-crosshairs');
                })
            }
        }
        
        if (prevProps.avanzado !== this.props.avanzado) {
            if (this.props.avanzado) {
                let element = $('.avanzado');
                $('body,html').stop(true, true).animate({scrollTop: element.offset().top}, 1000);
            } else {
                let element = $('#animals-filter');
                $('body,html').stop(true, true).animate({scrollTop: element.offset().top}, 1000);
            }
        }
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default EntitiesFilter
